import generateBasicEntityActions from "./generateBasicEntityActions";
import * as schemas from "../schemas";

const basicEntityActions = generateBasicEntityActions("fiSwapSuggestions");
const fiSwapSuggestionActions = {
  merge: (primaryId, secondaryId) => ({
    API_CALL: {
      httpMethod: "PUT",
      endpoint: "fiSwapSuggestions/merge",
      params: {
        id_primary: primaryId,
        id_secondary: secondaryId,
      },
    },
  }),
  fetchAllSimple: () => ({
    API_CALL: {
      httpMethod: "GET",
      endpoint: "simpleFiSwapSuggestions",
      schema: { fiSwapSuggestions: [schemas.fiSwapSuggestion] },
    },
  }),
  destroyAll: (params) => ({
    API_CALL: {
      httpMethod: "PUT",
      endpoint: "fiSwapSuggestions/destroy_all",
      params,
    },
  }),

  ...basicEntityActions,
};

export default fiSwapSuggestionActions;
